import { IExportForm } from './types';

export const exportReducer = (
    form: IExportForm,
    update: IExportForm
): IExportForm => ({
    ...form,
    ...update
})
